import { Box, Typography } from '@mui/material';
import { Divider } from '@ghs/components';
import React from 'react';
import type { SxProps } from '@mui/material';

type Props = {
  title: string;
  children: React.ReactNode;
  sx?: SxProps;
};

export default function SectionBox({ title, children, sx }: Props) {
  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3, ...sx }}>
      <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}
